<template>
    <v-card color="bgtopology" elevation="0">
        <v-card-title class="pa-0">
            <div class="ml-4">
                <span class="subtitleDashboard"> {{ t('labels.ociTitle') }} <span class="subtitleDashboard" style="font-size: 24px !important;" >{{ t('labels.oci') }}</span> </span>
            </div>
        </v-card-title>
        
        <v-card-text class="pa-0" style="text-align: -webkit-center;">
            <v-sheet class="gaugeClass" color="transparent" v-if="showGraph" :width="smAndDown ? '395' :'100%'" height="400" >
                <!-- Hexágono 1: Ahora (En línea / Últimos 15 min) -->
                <HexagonMinComponent 
                class="HexagonPos Hex1"
                :title="metricsData.now.toFixed(0)"
                :color="'red'"
                :subtitle="t('labels.online')"                
                :minValue="minValue"
                :maxValue="maxValue"
                :size-hexa="160"
                :size-title="55"
                :size-sub-ti="16"
                />
                <!-- Hexágono 2: Hoy -->
                <HexagonMinComponent 
                class="HexagonPos Hex2"
                :title="metricsData.today.toFixed(0)"
                :color="''"
                :subtitle="t('labels.day')"
                :minValue="minValue"
                :maxValue="maxValue"
                :size-hexa="sizeHexa"
                :size-title="sizeTitl"
                :size-sub-ti="sizeSubt"
                />
                <!-- Hexágono 3: Hace 2 días -->
                <HexagonMinComponent 
                class="HexagonPos Hex3"
                :title="metricsData.twoDaysAgo.toFixed(0)"
                :color="''"
                :subtitle="'2 ' + t('labels.day') + 's'"
                :minValue="minValue"
                :maxValue="maxValue"
                :size-hexa="sizeHexa"
                :size-title="sizeTitl"
                :size-sub-ti="sizeSubt"
                /> 
                <!-- Hexágono 4: Ayer -->
                <HexagonMinComponent 
                class="HexagonPos Hex4"
                :title="metricsData.yesterday.toFixed(0)"
                :color="''"
                :subtitle="'Ayer'"
                :minValue="minValue"
                :maxValue="maxValue"
                :size-hexa="sizeHexa"
                :size-title="sizeTitl"
                :size-sub-ti="sizeSubt"
                />
           </v-sheet>
           <v-row class="pt-5" v-if="!showGraph" justify="center">
                <Prog_circular/>
           </v-row>
        </v-card-text>
    </v-card>
 </template>
 
<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import type { PropType } from 'vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL } from '@/constants/labels';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { smAndDown } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
import HexagonMinComponent from '@/components/principalPage/hexagonMinComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

export interface MetricPeriod {
    now: number;
    today: number;
    yesterday: number;
    twoDaysAgo: number;
}

const props = defineProps({
    arrayItems : { 
        type: Object as PropType<MetricPeriod>, 
        default: () => ({ now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 }) 
    },
    valorCard  : { type: String, default: 'distri' }
});

const minValue = ref(60);
const maxValue = ref(90);
const sizeHexa = ref(120);
const sizeTitl = ref(30);
const sizeSubt = ref(13);

// watch(minValue, (valor: number) => {
//     const limitValue = ref(maxValue.value - 1);
//     if (valor >= limitValue.value && valor > 0) minValue.value = limitValue.value;
//     if (valor < 0) { minValue.value = 1; }
// });

// watch(maxValue, (valor: number) => {
//     const limitValue = ref(minValue.value + 1);
//     if (valor <= limitValue.value && valor < 100 && valor > 0) minValue.value = limitValue.value;
//     if (valor > 100) maxValue.value = 99;
// });

const valorCard = computed(() => props.valorCard);

const metricsData = computed<MetricPeriod>(() => {
    return props.arrayItems || { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 };
});

const showGraph = computed(() => !!props.arrayItems);

watch(metricsData, (newData) => {
    if (newData) {
        const okVal = newData.now.toFixed(0);
        if (valorCard.value === STRING_GENERAL.distri) store.commit('setIEODistri', okVal);
        if (valorCard.value === STRING_GENERAL.access) store.commit('setIEOAcceso', okVal);
        if (valorCard.value === STRING_GENERAL.client) store.commit('setIEOClient', okVal);
    }
}, { immediate: true, deep: true });
</script>

<style>
.boderCard{
    border: 0.1px solid rgba(0,0,0,.3);
    border-radius: 10px;
    margin: 0 0.3px;
    align-self: center;
}

.subtitleTUM, .subtitleTUM2{
    padding-top: 108px !important;
    padding-bottom: 20px !important;
}
.subtitleTUM2{
    padding-top: 180px !important;
}

.TUMtitle{
    position: absolute;
    z-index: 3;
    top: 90%;
    left: 17%;
    cursor: pointer;
    font-family: 'Poppins',sans-serif;
    font-weight: 400;
    font-size: 20px;
}

.menuGauge .v-input__append{
    margin: 0 !important;
}
.centerCard{
    align-content: center; 
    text-align: center;
}

.gaugeCardFilter {
    border-style: none none solid none;
    border-width: 8px;
    border-start-start-radius: 5px;
}
.cardBorderColorGreen{
    border-color: #427739;
}
.cardBorderColorRed{
    border-color: #E04637;
}
.cardBorderColorYellow{
    border-color: #F9DC4B;
}
.subtitleGAUGE{
    font-size: 20px;
    font-weight: bold;
}
.gaugeClass {
    position:relative;
}

.gaugeClass .HexagonPos{
    position: absolute;
    z-index: 2;
}
.Hex1{
    left: 6%;
    top: 30%;
}
.Hex2{
    left: 42%;
    top: 19.5%;
}
.Hex3{
    left: 42%;
    top: 50%;
}
.Hex4{
    left: 69%;
    top: 35%;
}
</style>